/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/11 13:15
 * Description:
 */

import Vue from 'vue'
import moment from 'moment'
import initStore from './store'
// import initRouter from './utils/router'
import '../promission'

import { setEnableRole } from './utils/roles'

import http from './utils/request';

import ElementUI from 'element-ui'
import events from './utils/events'
import timeout from './utils/timeout'
import roles from './utils/roles'
import ECharts from 'vue-echarts'
import echarts from 'echarts'
import vueCropper from 'vue-cropper'


import WRouterView from './components/w-router-view'
import MMap from './components/m-map'
import WSidebar, { setSidebarMenu } from './components/sidebar';
import EventEmitter from 'events';
import VueCookies from 'vue-cookies'
import jsPlumb  from "jsplumb";
import FileSaver from 'file-saver'
import XLSX from 'xlsx'


import FullCalendar from 'vue-fullcalendar';


// import '../../public/vue-ueditor-wrap.min.js'

// import '../../public/UEditor/ueditor.config.js'
// import '../../public/UEditor/ueditor.all.min.js'
// import '../../public/UEditor/lang/zh-cn/zh-cn.js'

let crypto = require('crypto');

Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    if(!value || isNaN(value)) return '';
    value = value*1;
    return moment(value).format(formatString); // 这是时间戳转时间
});
Vue.filter('showParticipant',function (value) {
    if (value.length!=0){
        let str=value.join('   ')
        return str
    }
})
Vue.filter("tableVal",function (value, arr,type='d') {
    // type  : d  默认值代表数字字典   t  代表分类     n 公司(name)
    // console.log(arr,type);
   if(!arr) return '无';
   if(arr && arr.length == 0) return "无";

   let res = arr.filter(item => item.id == value);
   let str = "";
   if(!res.length){
       str =  "无";
       return ;
   };
   if(type == 'd'){
       str = res[0].cname
   };
    if(type == 't'){
        str = res[0].title
    };
    if(type == 'n'){
        str = res[0].name
    };
   return str;
});
Vue.filter("getCname",function (value, arr,type='d') {
    // type  : d  默认值代表数字字典   t  代表分类     n 公司(name)
    // console.log(arr,type);

    if(!arr) return '无';
    if(arr && arr.length == 0) return "无";

    let res = arr.filter(item => item.ename == value);
    let str = "";
    if(!res.length){
        str =  "无";
        return ;
    }
    if(type == 'd'){
        str = res[0].cname
    };
    if(type == 't'){
        str = res[0].title
    };
    if(type == 'n'){
        str = res[0].name
    };
    return str;
});
Vue.prototype.getNameById = function (id,arr) {
    if(!arr) return "无";
    if(arr && arr.length == 0) return "无";
    let res = arr.filter(item => item.id == id);
    if(!res.length){
        return "无"
    }else{
        return res[0].cname;
    }
};
Vue.prototype.getNameByDefault = function(id, arr) {
    id = `${id}`
    if (!arr) return "无";
    if (arr && arr.length == 0) return "无";
    let res = arr.filter(item => `${item.default}` == id);
    if (!res.length) return "无"
    return res[0].cname
};
Vue.prototype.$jsPlumb = jsPlumb.jsPlumb;

Vue.prototype.format = function (time,formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    if(!time || isNaN(time)) return '';
    return moment(time).format(formatString); // 这是时间戳转时间
};

// 加密
Vue.prototype.md5 = function (str) {
    var md5Sum = crypto.createHash('md5');
    md5Sum.update(str);
    str = md5Sum.digest('hex');
    return str;
};
//table导出功能
Vue.prototype.$exportTable=function(id='out_export',name,startTime,endTime,){

    let xlsxParam={raw:true}   //保证表格数据按照原始数据格式不变
    // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
    var fix = document.getElementsByClassName('el-table__fixed')[0]
    var wb;
    if (fix) {
        if(id == 'personStatis'){//如果是派工统计页面的表格
            wb = XLSX.utils.table_to_book(document.getElementById(id).removeChild(fix),{raw:true});
            document.getElementById(id).appendChild(fix);
        }else{
            wb = XLSX.utils.table_to_book(document.getElementById(id).removeChild(fix));
            document.getElementById(id).appendChild(fix);
        }
    } else {
        wb = XLSX.utils.table_to_book(document.getElementById(id),xlsxParam);
    }
    // let wb=XLSX.utils.table_to_book(document.getElementById("out_export"),xlsxParam)
    let wbout=XLSX.write(wb,{
        bookType:'xlsx',
        bookSST:true,
        type:"array",
    })
    try {
        FileSaver.saveAs(
            new Blob([wbout],{type:"application/octet-stream"}),`${name}${startTime}${endTime}.xlsx`
        )
    }catch (e) {
        // console.log(err);
        if (typeof console !=='undefined') console.log(e,wbout)
    }
    return wbout
}

//echarts
Vue.prototype.$echarts=echarts

Vue.use(ElementUI, {
    size: 'mini'
});

Vue.use(VueCookies)
//注册echart组件，OperatingKanban https://github.com/Justineo/vue-echarts/blob/master/demo/Demo.vue
Vue.component('e-charts', ECharts);
Vue.component('w-router-view', WRouterView);
Vue.component('m-map', MMap);
Vue.component('w-sidebar', WSidebar);
Vue.use(FullCalendar);
Vue.use(vueCropper)

Vue.config.productionTip = false;

Vue.eventEmitter = new EventEmitter();


import './style/core.scss';

function VueUse(...arg) {
	Vue.use(...arg);
}

export {
    initRouter,
    initStore,
    http,
	VueUse,
	setEnableRole,
    setSidebarMenu
}

export default async function ({el, store, routes, App},enableRole = false) {
	Vue.prototype.$enableRole = enableRole;
    let storeArr = await initStore(store)
    return new Vue({
        router: routes,
        // router: initRouter(routes),
        // store: initStore(store),
        store:storeArr,
        components: {App},
        render: (h) => h(App),
        data:{
            Bus:new Vue()
        }
    }).$mount(el);
}
